// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tournament Score Entry Tab Styles */
.tournament-score-entry-tab,
.admin-tournament-score-entry-tab {
  height: 100%;
}

.score-entry-content {
  padding: 20px 30px 30px 30px;
  display: grid;
  gap: 24px;
}

.score-entry-form-section {
  padding: 24px;
  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.score-entry-form-section h3 {
  margin: 0 0 20px 0;
  color: #1e293b;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 2px solid #e5e7eb;
  padding-bottom: 8px;
}

.score-entry-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.A-form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.A-form-group label {
  font-weight: 600;
  color: #374151;
  font-size: 14px;
}

.form-select {
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  background-color: white;
  color: #1e293b;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 0.2rem rgba(59, 130, 246, 0.25);
}

.form-select:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  opacity: 0.6;
  cursor: not-allowed;
}

.A-player-info {
  margin-top: 4px;
  padding: 8px 12px;
  background-color: #f1f5f9;
  border-radius: 4px;
  border-left: 3px solid #3b82f6;
}

.A-player-info small {
  color: #6b7280;
  font-size: 12px;
}

.A-form-help {
  color: #6b7280;
  font-size: 12px;
  margin-top: 4px;
}

.score-summary {
  margin-top: 20px;
}

.summary-card {
  background-color: #f1f5f9;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 20px;
}

.summary-card h4 {
  margin: 0 0 16px 0;
  color: #1e293b;
  font-size: 16px;
  font-weight: 600;
}

.summary-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 16px;
}

.summary-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.summary-item .label {
  font-size: 12px;
  color: #6c757d;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.summary-item .value {
  font-size: 18px;
  font-weight: 700;
}

.score-value {
  color: #212529;
}

.par-value {
  color: #007bff;
}

.to-par-value {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 16px;
}

.to-par-value.under {
  background-color: #d4edda;
  color: #155724;
}

.to-par-value.even {
  background-color: #fff3cd;
  color: #856404;
}

.to-par-value.over {
  background-color: #f8d7da;
  color: #721c24;
}

.A-form-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e9ecef;
}

.submit-score-btn {
  flex: 1 1;
  max-width: 200px;
}

.reset-form-btn {
  flex: 1 1;
  max-width: 150px;
}

.instructions-section {
  padding: 24px;
}

.instructions-section h3 {
  margin: 0 0 16px 0;
  color: #212529;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 2px solid #f8f9fa;
  padding-bottom: 8px;
}

.instructions-content ul {
  margin: 0 0 16px 0;
  padding-left: 20px;
}

.instructions-content li {
  margin-bottom: 8px;
  color: #495057;
  line-height: 1.5;
}

.instructions-content li strong {
  color: #212529;
}

.important-note {
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 6px;
  padding: 16px;
  margin-top: 16px;
}

.important-note strong {
  color: #856404;
}

.important-note {
  color: #856404;
  font-size: 14px;
  line-height: 1.5;
}

.status-warning {
  padding: 24px;
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
}

.status-warning h3 {
  margin: 0 0 12px 0;
  color: #856404;
  font-size: 18px;
  font-weight: 600;
}

.status-warning p {
  margin: 0;
  color: #856404;
  line-height: 1.5;
}

/* Responsive adjustments for score entry */
@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  
  .summary-details {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .A-form-actions {
    flex-direction: column;
  }
  
  .submit-score-btn,
  .reset-form-btn {
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/admin/tournament/TournamentScoreEntryTab.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;;EAEE,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,wEAAwE;AAC1E;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/* Tournament Score Entry Tab Styles */\n.tournament-score-entry-tab,\n.admin-tournament-score-entry-tab {\n  height: 100%;\n}\n\n.score-entry-content {\n  padding: 20px 30px 30px 30px;\n  display: grid;\n  gap: 24px;\n}\n\n.score-entry-form-section {\n  padding: 24px;\n  background-color: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.score-entry-form-section h3 {\n  margin: 0 0 20px 0;\n  color: #1e293b;\n  font-size: 18px;\n  font-weight: 600;\n  border-bottom: 2px solid #e5e7eb;\n  padding-bottom: 8px;\n}\n\n.score-entry-form {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n}\n\n.A-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.A-form-group label {\n  font-weight: 600;\n  color: #374151;\n  font-size: 14px;\n}\n\n.form-select {\n  padding: 12px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n  background-color: white;\n  color: #1e293b;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.form-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 0.2rem rgba(59, 130, 246, 0.25);\n}\n\n.form-select:disabled {\n  background-color: #f9fafb;\n  color: #6b7280;\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.A-player-info {\n  margin-top: 4px;\n  padding: 8px 12px;\n  background-color: #f1f5f9;\n  border-radius: 4px;\n  border-left: 3px solid #3b82f6;\n}\n\n.A-player-info small {\n  color: #6b7280;\n  font-size: 12px;\n}\n\n.A-form-help {\n  color: #6b7280;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.score-summary {\n  margin-top: 20px;\n}\n\n.summary-card {\n  background-color: #f1f5f9;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 20px;\n}\n\n.summary-card h4 {\n  margin: 0 0 16px 0;\n  color: #1e293b;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.summary-details {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 16px;\n}\n\n.summary-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.summary-item .label {\n  font-size: 12px;\n  color: #6c757d;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.summary-item .value {\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.score-value {\n  color: #212529;\n}\n\n.par-value {\n  color: #007bff;\n}\n\n.to-par-value {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 16px;\n}\n\n.to-par-value.under {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.to-par-value.even {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.to-par-value.over {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.A-form-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid #e9ecef;\n}\n\n.submit-score-btn {\n  flex: 1;\n  max-width: 200px;\n}\n\n.reset-form-btn {\n  flex: 1;\n  max-width: 150px;\n}\n\n.instructions-section {\n  padding: 24px;\n}\n\n.instructions-section h3 {\n  margin: 0 0 16px 0;\n  color: #212529;\n  font-size: 18px;\n  font-weight: 600;\n  border-bottom: 2px solid #f8f9fa;\n  padding-bottom: 8px;\n}\n\n.instructions-content ul {\n  margin: 0 0 16px 0;\n  padding-left: 20px;\n}\n\n.instructions-content li {\n  margin-bottom: 8px;\n  color: #495057;\n  line-height: 1.5;\n}\n\n.instructions-content li strong {\n  color: #212529;\n}\n\n.important-note {\n  background-color: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 6px;\n  padding: 16px;\n  margin-top: 16px;\n}\n\n.important-note strong {\n  color: #856404;\n}\n\n.important-note {\n  color: #856404;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.status-warning {\n  padding: 24px;\n  background-color: #fff3cd;\n  border: 1px solid #ffeaa7;\n}\n\n.status-warning h3 {\n  margin: 0 0 12px 0;\n  color: #856404;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.status-warning p {\n  margin: 0;\n  color: #856404;\n  line-height: 1.5;\n}\n\n/* Responsive adjustments for score entry */\n@media (max-width: 768px) {\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .summary-details {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  \n  .A-form-actions {\n    flex-direction: column;\n  }\n  \n  .submit-score-btn,\n  .reset-form-btn {\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
